module.exports = __webpack_public_path__ + "static/media/aodocs.b183d2aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/aodocs.svg
// module id = 656
// module chunks = 0